package com.essntl.features.dashboard.ui.components.taskcard

import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.width
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextOverflow
import com.essntl.features.task.domain.model.TaskModel
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.icons.EsMediumIcon
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@Composable
fun ItineraryTask(
    task: TaskModel,
) {
    Row {
        EsMediumIcon(
            res = EsIcons.Itinerary,
            tint = MaterialTheme.esColorScheme.iconPrimary,
        )

        Spacer(modifier = Modifier.width(1.spacing))

        Text(
            text = task.itinerary?.proposal?.title ?: "itinerary name",
            style = MaterialTheme.esTypography.p2Medium14,
            overflow = TextOverflow.Ellipsis,
        )
    }
}